import React, {useEffect} from "react"
import "../src/harness/config"
import decorate from "../src/harness/decorate"
import {COMMANDS} from "../src/harness/cmds"
import useCurrentUser from "../src/harness/hooks/use-current-user"
import useConfig from "../src/harness/hooks/use-config"

const renderCommand = (d: any) => {
  return (
    <li key={d.LABEL}>
      <button onClick={d.CMD}>{d.LABEL}</button>
    </li>
  )
}

export default function Page() {
  useEffect(() => {
    decorate()
  })

  const currentUser = useCurrentUser()
  const config = useConfig()

  return (
    <div>
      <pre>
        emulator servicePrivKey should be
        f8e188e8af0b8b414be59c4a1a15cc666c898fb34d94156e9b51e18bfde754a5
      </pre>
      <ul>{COMMANDS.map(renderCommand)}</ul>
      <pre>{JSON.stringify({currentUser, config}, null, 2)}</pre>
    </div>
  )
}
